import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadphones } from "@fortawesome/free-solid-svg-icons";

const ListenButton = ({ href, text }) => {
  const isExternal =
    href && (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("//") || href.startsWith("mailto:"));

  if (isExternal) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-capitalize buybutton"
      >
        <FontAwesomeIcon icon={faHeadphones} /> {text}
      </a>
    );
  }

  return (
    <Link to={href || "#"} className="text-capitalize buybutton">
      <FontAwesomeIcon icon={faHeadphones} /> {text}
    </Link>
  );
};

export default ListenButton;